export const slowDeltaFactor = 0.01
export const lerpInterpolationValue = 0.08
export const lerpInterpolationValueRocket = 0.04
